import { ControlPackage, ensureSet } from '@controls/Base';
import { createElement } from 'react';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import Button from './Button';
import Control from './Control';
import Props from './Props';
import PropsDescriptor from './PropsDescriptor';
import renderFDO from './RenderFDO';

const createButton = (parentId?: number | undefined): Control => ({
    globalId: -1,
    parentId,
    name: 'NewButton',
    type: 'button',
    actionFDO: '',
    properties: {
        caption: 'Button',
        position: {
            placement: 'precise',
            top: 0,
            left: 0,
            width: 100,
            height: 20,
        },
        bgColor: '#ffffff',
        foreColor: '#000000',
        image: '',
        isDefault: false,
        fontFace: 'arial',
        fontSize: 12,
        fontBold: false,
        fontItalic: false,
        fontUnderline: false,
        triggerStyle: 'default',
    },
});

const upgradePropsVersion = (props: Props) => ensureSet(props, 'triggerStyle', 'default');

const buttonPackage: ControlPackage<Props, Control> = {
    type: 'button',
    icon: solid('hand-pointer'),
    canHaveChildren: false,
    canHaveAction: true,
    validParentTypes: ['window'],
    factory: createButton,
    propDescriptors: PropsDescriptor,
    // eslint-disable-next-line react/no-children-prop
    renderDesigner: controlId => createElement(Button, { controlId }),
    renderFDO,
    getPreviewRenderSize: props =>
        props.image && props.position.placement === 'precise'
            ? [props.position.width, props.position.height + (props.caption ? props.fontSize + 4 : 0)]
            : [undefined, undefined],
    upgradePropsVersion,
};

export default buttonPackage;
